import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BusinessMetricsIndexRoute extends Route {
  @service router;

  beforeModel() {
    this.router.transitionTo('business.metrics.list');
  }
}

export default instrumentRoutePerformance(BusinessMetricsIndexRoute);
